// web_managerSupplier_updateOfExpirationTime 可批量修改流水到期时间

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址： http://192.168.0.15:8080/doc.html#/所有接口/manager-supplier-controller/updateOfExpirationTimeUsingPOST

export default function web_managerSupplier_updateOfExpirationTime(pParameter) {
  if (!pParameter) pParameter = {};
  const ids = pParameter.ids || ''
  const ofExpirationTime = pParameter.ofExpirationTime || ''
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/managerSupplier/updateOfExpirationTime'
  params.data = {
    ids,
    ofExpirationTime
  }
  return new Promise(function(resolve, reject) {
    resolve(__request(params))
  })
}

